"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var styled_components_1 = __importStar(require("styled-components"));
var ImageDiv = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\twidth: 32px;\n\theight: 32px;\n"], ["\n\twidth: 32px;\n\theight: 32px;\n"])));
var BadgeDiv = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tposition: relative;\n\t", "\n"], ["\n\tposition: relative;\n\t", "\n"])), function (props) { return props.theme.badge; });
var Counter = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\tline-height: 1px;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\t", "\n"], ["\n\tline-height: 1px;\n\tposition: absolute;\n\tleft: 50%;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n\t", "\n"])), function (props) { return props.theme.counter; });
var ContextRow = styled_components_1.default.tr(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\t", ";\n"], ["\n\t", ";\n"])), function (props) { return props.theme.contextOption; });
var ContextElement = styled_components_1.default.td(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n\tpadding: 8px 8px;\n\t@media ", " {\n\t\tpadding: 6px 3px;\n\t}\n"], ["\n\tpadding: 8px 8px;\n\t@media ", " {\n\t\tpadding: 6px 3px;\n\t}\n"])), function (props) { return props.theme.breakpoints.S; });
var ContextOption = /** @class */ (function (_super) {
    __extends(ContextOption, _super);
    function ContextOption() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContextOption.prototype.render = function () {
        var _this = this;
        var badge = (react_1.default.createElement("div", null));
        if (this.props.count && this.props.count !== 0) {
            badge = react_1.default.createElement(BadgeDiv, null,
                react_1.default.createElement(Counter, null, this.props.count));
        }
        return (react_1.default.createElement(ContextRow, { "data-automationid": this.props.automationId, "aria-label": this.props.text, disabled: this.props.disabled === true, onClick: function () {
                if (window.options_tagger !== undefined && _this.props.taggingOverride !== "notag") {
                    if (_this.props.taggingOverride) {
                        window.options_tagger(_this.props.taggingOverride);
                    }
                    else if (_this.props.automationId) {
                        window.options_tagger(_this.props.automationId);
                    }
                }
                _this.props.onClick();
            } },
            react_1.default.createElement(ContextElement, null, badge),
            react_1.default.createElement(ContextElement, null, this.props.text),
            react_1.default.createElement(ContextElement, null,
                react_1.default.createElement(ImageDiv, null, this.props.icon))));
    };
    ContextOption.propTypes = {
        /** React renderable */
        icon: prop_types_1.default.node.isRequired,
        /** function to call on click */
        onClick: prop_types_1.default.func.isRequired,
        /** Id to reference the button by in functional testing */
        automationId: prop_types_1.default.string.isRequired,
        /** If a change to the tagging identity is requested but we don't want to change the automationId, use this (set to 'notag' to block tagging) */
        taggingOverride: prop_types_1.default.string,
        /** Text to display on the button and in the accessiblity info */
        text: prop_types_1.default.string.isRequired,
        /** applicable number to show if there is one */
        count: prop_types_1.default.oneOfType([prop_types_1.default.number, prop_types_1.default.string]),
        disabled: prop_types_1.default.bool
    };
    ContextOption.defaultProps = {
        icon: '',
        onClick: function () { },
        automationId: '',
        text: '',
        count: 0
    };
    return ContextOption;
}(react_1.Component));
exports.default = styled_components_1.withTheme(ContextOption);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=ContextOption.js.map